import React, { Component } from "react";

import { Translate, I18n } from "react-redux-i18n";

import { momentModule, roundToDecimals } from "../../utils/Utils";

import Rating from "../../utils/components/Rating";

import star from "../../../styles/images/star_grey.svg";
import battery from "../../../styles/images/battery_grey.svg";
import energy from "../../../styles/images/energy_grey.svg";
import clock from "../../../styles/images/clock.svg";
import money from "../../../styles/images/money_grey.svg";
import timed_battery from "../../../styles/images/timed_battery.svg";
import timed_energy from "../../../styles/images/timed_energy.svg";
import marker from "../../../styles/images/markers/marker_public_grey.svg";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";

const { moment } = momentModule;

class StatsRow extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="top-row">
        {this.props.type === "charger" && (
          <div id="chargerRating" className="highlight-container muted">
            <div className="highlight-container-header">
              <img src={star} alt="" />
              <Translate value="insightsByCharger_rating" />
            </div>
            <div className="highlight-container-body">
              <div className="rating">
                <Rating value={Math.round(this.props.data?.charger?.charger?.rating)} />
                {roundToDecimals(this.props.data?.charger?.charger?.rating, 1)}
              </div>
            </div>
          </div>
        )}
        <div id="sessions" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={battery} alt="" />
            <Translate
              value={
                this.props.type === "ev"
                  ? "insightsByCar_sessions"
                  : "insightsByCharger_myChargersSessions"
              }
            />
          </div>
          <div className="highlight-container-body">{this.props.data?.sessions || 0}</div>
        </div>
        <div id="totalEnergy" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={energy} alt="" />
            <Translate value="insightsByCar_totalEnergy" />
          </div>
          <div className="highlight-container-body">
            {this.props.data?.totalEnergy > 1
              ? `${roundToDecimals(
                  this.props.data?.totalEnergy,
                  this.props.data?.totalEnergy > 9 ? 1 : 3
                )}kWh`
              : this.props.data?.totalEnergy > 0
              ? `${roundToDecimals(
                  this.props.data?.totalEnergy * 1000,
                  this.props.data?.totalEnergy * 1000 > 9 ? 1 : 3
                )}Wh`
              : "0Wh"}
          </div>
        </div>
        <div id="totalChargingTime" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={clock} alt="" />
            <Translate value="insightsByCar_totalChargingTime" />
          </div>
          <div className="highlight-container-body">
            {moment.duration(this.props.data?.totalChargingTime, "hours").format("h[h] m[m]")}
          </div>
        </div>
        {this.props.type === "charger" && (
          <div id="totalSpent" className="highlight-container muted">
            <div className="highlight-container-header">
              <img src={money} alt="" />
              <Translate value="insightsByCar_totalSpent" />
            </div>
            <div className="highlight-container-body">{`${roundToDecimals(
              this.props.data?.purchaseTariffDetailsExclVat,
              2
            )}€`}</div>
          </div>
        )}
        <div id="totalSpent" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={money} alt="" />
            <Translate
              value={
                this.props.type === "ev"
                  ? "insightsByCar_totalSpent"
                  : "insightsByCharger_totalIncome"
              }
            />
          </div>
          <div className="highlight-container-body">
            {this.props.type === "ev"
              ? `${roundToDecimals(this.props.data?.totalSpendExclVat, 2)}€`
              : `${roundToDecimals(this.props.data?.incomeExclVat, 2)}€`}
          </div>
        </div>
        <div id="avgSessionChargingTime" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={timed_battery} alt="" />
            <Translate value="insightsByCar_avgSessionChargingTime" />
          </div>
          <div className="highlight-container-body">
            {moment
              .duration(this.props.data?.averageChargingTimeSession, "hours")
              .format("h[h] m[m]")}
          </div>
        </div>
        <div id="avgSessionEnergyCharged" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={timed_energy} alt="" />
            <Translate value="insightsByCar_avgSessionEnergyCharged" />
          </div>
          <div className="highlight-container-body">
            {this.props.data?.averageEnergyChargedSession > 1
              ? `${roundToDecimals(this.props.data.averageEnergyChargedSession, 2)}kWh`
              : this.props.data?.averageEnergyChargedSession > 0
              ? `${roundToDecimals(this.props.data.averageEnergyChargedSession * 1000, 2)}Wh`
              : "0Wh"}
          </div>
        </div>
        <div id="favouriteCP" className="highlight-container muted">
          <div className="highlight-container-header">
            <img src={marker} alt="" />
            <Translate
              value={
                this.props.type === "ev"
                  ? "insightsByCar_favouriteCP"
                  : "insightsByCharger_mostUsedPlug"
              }
            />
          </div>
          <div className="highlight-container-body">
            {this.props.type === "ev" ? (
              <div className="favourite-charger">
                {this.props.data?.mostUsedCharger?.name || <Translate value="insights_noData" />}
                {this.props.data?.mostUsedCharger && (
                  <Rating value={Math.round(this.props.data.mostUsedCharger.rating)} />
                )}
              </div>
            ) : (
              <div className="most-used-plug">
                {this.props.data?.mostUsedPlug ? (
                  `${I18n.t("insightsByCharger_plug")} ${this.props.data.mostUsedPlug}`
                ) : (
                  <Translate value="insights_noData" />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StatsRow;
